module.exports = __webpack_public_path__ + "/static/assets/60fc7acc624571cfa9d250d7d5cff041.svg";